import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NewBookingNumberPageComponent } from './new-booking-number.page';

const routes: Routes = [
  {
    path: '',
    component: NewBookingNumberPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewItemNumberPageRoutingModule {}
